import { render, staticRenderFns } from "./CursorContainer.vue?vue&type=template&id=2bdad8a6&scoped=true&"
import script from "./CursorContainer.vue?vue&type=script&lang=js&"
export * from "./CursorContainer.vue?vue&type=script&lang=js&"
import style0 from "./CursorContainer.vue?vue&type=style&index=0&id=2bdad8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdad8a6",
  null
  
)

export default component.exports